
const AccountPreferenceContainerHelper = {

    onPbToggleOnOffClick(bpNumber, contractAccountNumber){
      let updatedState = { ...this.state };
      //let eBillpreferenceEmail = [];
      updatedState.contractAccountNumber = contractAccountNumber;
      let mainBpNumber = app.appService.getUserInfo().profileData.accountData.mainBusinessPartner.businessPartnerNumber;
      let catResults = this.state.serachMode?this.state.contractAccountSearchList.contractAccountResults:this.state.cpcData.contractAccountResults;
      let contractNumberCount = catResults.filter(data=>{
          if(data.contractAccountNumber === contractAccountNumber) 
            {return data.contractNumbercount;}
    });
      app.centralizedService.geteBillPreferencesContractAccountPref(contractNumberCount[0].bpNumber, contractAccountNumber, updatedState.isWebUser).then((response) => {
        if (response.errorCode !== undefined && response.errorCode !== "") {
          //to be completed
          //this.setState({ errorCard: true, });
        } else {
          this.setState({ebillpaprCount: response.customerEbillPreferences.results[0].count});
         let res=response.customerEbillPreferences.results[0].qryObjSumQryBPChnlSumNav.results;
            app.appService.setSessionstorage('pbBuPartner', res[0].buPartner);
            app.appService.setSessionstorage('pbBuPartner2', res[0].buPartner2);
           let ebillpaprRecord={record:[]}, ebillpaprSold={record:[]}, ebillpaprAuth={record:[]};
          res.map((record) => {
            //if (record.record_guid !== null){
              //eBillpreferenceEmail.push(record.email_id);
              //paprRecord.record=record;
              //ebillpaprRecord.record.push(record.qryBPChnlSumQryPreSumNav.results[0]);
            let results=record.qryBPChnlSumQryPreSumNav.results;
            results.map((result) => {
            ebillpaprRecord.record.push(result);
            (mainBpNumber === record.buPartner || record.buPartner2) ? ebillpaprSold.record.push(result) : ebillpaprAuth.record.push(result);
                });
             // }
            });
          //updatedState.preferenceDetails[0].papr.email_id = preferenceEmail;
          this.setState({contractAccountNumber: contractAccountNumber, contractNumberCount: contractNumberCount[0].contractNumbercount,ebillpaprRecord:ebillpaprRecord,ebillpaprSold: ebillpaprSold,ebillpaprAuth: ebillpaprAuth  });}
      });
    }
  };
  export default AccountPreferenceContainerHelper;
